"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MTASummaryWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var MTASummaryWidget = /** @class */ (function (_super) {
    __extends(MTASummaryWidget, _super);
    function MTASummaryWidget(props) {
        return _super.call(this, props) || this;
    }
    MTASummaryWidget.prototype.renderInputField = function () {
        var vehicle = this.props.interaction.vehicles[0];
        var date = new Date(this.props.interaction.headerInfo.startDate).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
        return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("p", { children: [(0, jsx_runtime_1.jsxs)("strong", { children: ["Great news! There is no change in price for the changes you have made from the ", date, " to the end of your policy."] }), " You have chosen to:"] }), (0, jsx_runtime_1.jsx)("ul", { children: (0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsxs)("strong", { children: ["Amend your car registration number (", vehicle.registrationNumber, ") for your ", vehicle.make, " ", vehicle.model] }) }) })] }));
    };
    return MTASummaryWidget;
}(plugin_journey_1.QuestionWidgetBase));
exports.MTASummaryWidget = MTASummaryWidget;
//# sourceMappingURL=MTASummaryWidget.js.map